// src/utils/toQS.ts

/**
 * Converts a payload object into a query string.
 * - Removes null/undefined/empty values.
 * - Automatically adds `?` prefix.
 * - Returns '' if no params.
 *
 * Example:
 *   toQS({ page: 2, search: 'abc' })
 *   -> "?page=2&search=abc"
 */
export function toQS(
  params?: Record<string, string | number | boolean | null | undefined>
): string {
  if (!params) return '';

  const entries = Object.entries(params).filter(
    ([, v]) => v !== undefined && v !== null && v !== ''
  );

  if (!entries.length) return '';

  const qs = new URLSearchParams();
  for (const [key, value] of entries) {
    qs.append(key, String(value));
  }

  return `?${qs.toString()}`;
}

export default toQS;
